var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2712 6.85482C13.2712 3.39028 10.4649 0.583984 7.00033 0.583984C3.53578 0.583984 0.729492 3.39028 0.729492 6.85482C0.729492 10.3194 3.53578 13.1257 7.00033 13.1257C10.4649 13.1257 13.2712 10.3194 13.2712 6.85482ZM1.60449 6.85482C1.60449 3.87353 4.01903 1.45898 7.00033 1.45898C9.98162 1.45898 12.3962 3.87353 12.3962 6.85482C12.3962 9.83611 9.98162 12.2507 7.00033 12.2507C4.01903 12.2507 1.60449 9.83611 1.60449 6.85482ZM7.43783 3.50065C7.43783 3.25903 7.24195 3.06315 7.00033 3.06315C6.7587 3.06315 6.56283 3.25903 6.56283 3.50065V6.85055C6.56283 7.08604 6.67655 7.30703 6.86817 7.4439L8.7877 8.81499C8.98432 8.95543 9.25756 8.90989 9.398 8.71328C9.53844 8.51666 9.4929 8.24342 9.29628 8.10298L7.43783 6.77551V3.50065Z",
    fill: "#CACCCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.e9415f3b32cffdd4955927cc946a7810.svg";
export { ForwardRef as ReactComponent };